import { EvaluationMonth } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';
import { LanguageUtils } from '@provider-portal/common/utils/translations';

/** Maps an evaluation period (1-based month) to its localized month name. */
export function getMonthName({ year, month }: EvaluationMonth): string {
  const formatter = new Intl.DateTimeFormat(LanguageUtils.getAppLocaleWithFallback(), {
    month: 'long',
  });
  return formatter.format(new Date(year, month - 1, 1));
}
